(function () {
  'use strict';

  if (customElements.get('purchase-points-slider')) {
    return;
  }

  var DESKTOP_SLOTS = {
    centerXOffset: -90,
    centerYRatio: 0.6024,
    baseWidth: 1440,
    minScale: 0.68,
    maxScale: 1.6,
    // 固定绿色背景板尺寸：比卡片(280×408)大一圈，主卡照片落在其上即显大、且照片本身不缩放。
    boardWidth: 363,
    boardHeight: 528,
    positions: {
      // 所有槽位统一尺寸 280×408（偏小）：卡片切换时只平移+旋转、不再缩放（去掉「放大一下」）。
      // x/y = 卡片中心相对主卡中心的位移；rotation 由 CSS transform 叠加。
      '-1': { x: -447, y: 39, width: 280, height: 408, rotation: 0, opacity: 1, zIndex: 1 },
      '0': { x: 0, y: 0, width: 280, height: 408, rotation: -10, opacity: 1, zIndex: 4 },
      '1': { x: 404, y: -122, width: 280, height: 408, rotation: -20, opacity: 1, zIndex: 3 },
      '2': { x: 741, y: -279, width: 280, height: 408, rotation: -30, opacity: 1, zIndex: 2 },
      hiddenLeft: { x: -900, y: 120, width: 280, height: 408, rotation: 8, opacity: 0, zIndex: 0 },
      hiddenRight: { x: 1120, y: -430, width: 280, height: 408, rotation: -38, opacity: 0, zIndex: 0 },
    },
  };

  var MOBILE_SLOTS = {
    mainX: 0.5,
    mainY: 0.5,
    baseWidth: 390,
    minScale: 0.86,
    maxScale: 1.4,
    // 固定绿色背景板尺寸（按 Figma 移动端比例缩小约 8%，适配更紧凑的舞台高度）。
    boardWidth: 280,
    boardHeight: 365,
    // 绿边不对称「下唇」：右>左、下>上，取差值的一半占比。
    lipXFrac: 0.0114,
    lipYFrac: 0.035,
    positions: {
      // 照片统一 236×288。绿板倾斜 -10° 后两角几乎占满屏宽，邻卡必须放在绿板倾斜边最内缩的高度
      // （左卡≈居中、右卡偏上），并用较小旋转 + 拉远 x，才能与中间绿板留出明显空隙、不重叠（对齐图 2）。
      // width/height = 真实尺寸（旋转前），rotation 另行叠加。
      '-1': { x: -300, y: -3, width: 236, height: 288, rotation: -2, opacity: 0.42, zIndex: 1 },
      '0': { x: 0, y: 0, width: 236, height: 288, rotation: -10, opacity: 1, zIndex: 4 },
      '1': { x: 300, y: -46, width: 236, height: 288, rotation: -6, opacity: 0.42, zIndex: 3 },
      '2': { x: 430, y: -110, width: 236, height: 288, rotation: -12, opacity: 0.18, zIndex: 2 },
      hiddenLeft: { x: -540, y: 28, width: 236, height: 288, rotation: 4, opacity: 0, zIndex: 0 },
      hiddenRight: { x: 650, y: -150, width: 236, height: 288, rotation: -22, opacity: 0, zIndex: 0 },
    },
  };

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  customElements.define(
    'purchase-points-slider',
    class PurchasePointsSlider extends HTMLElement {
      constructor() {
        super();
        this.activeColorIndex = 0;
        this.activeSlideIndex = 0;
        this.pointerStartX = 0;
        this.pointerActive = false;
        this.didSwipe = false;
        this.resizeFrame = null;
        this.animTimer = null;
        this.autoplayTimer = null;

        this.handlePrev = this.handlePrev.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleSwatchClick = this.handleSwatchClick.bind(this);
        this.handleCardClick = this.handleCardClick.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handlePointerEnter = this.handlePointerEnter.bind(this);
        this.handlePointerLeave = this.handlePointerLeave.bind(this);
        this.handleVisibility = this.handleVisibility.bind(this);
      }

      connectedCallback() {
        this.stage = this.querySelector('.pps__stage');
        this.groups = Array.prototype.slice.call(this.querySelectorAll('.pps__group'));
        this.groupCards = Array.prototype.slice.call(this.querySelectorAll('.pps__card'));
        this.boards = Array.prototype.slice.call(this.querySelectorAll('.pps__board'));
        this.swatches = Array.prototype.slice.call(this.querySelectorAll('.pps__swatch'));
        this.descItems = Array.prototype.slice.call(this.querySelectorAll('.pps__desc-item'));
        this.prevBtn = this.querySelector('.pps__btn--prev');
        this.nextBtn = this.querySelector('.pps__btn--next');
        this.progressFill = this.querySelector('.pps__progress-fill');
        this.currentDot = this.querySelector('.pps__current-dot');
        this.currentName = this.querySelector('.pps__current-name');
        this.slideCount = parseInt(this.getAttribute('data-slide-count'), 10) || 4;
        this.desktopScale = (parseFloat(this.getAttribute('data-card-scale')) || 100) / 100;
        this.autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
        this.autoplaySpeed = (parseFloat(this.getAttribute('data-autoplay-speed')) || 3.5) * 1000;

        if (!this.stage || this.groups.length === 0 || this.slideCount < 1) {
          return;
        }

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.classList.add('is-ready');

        this.bindEvents();
        this.updateAll(false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);

        if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlePrev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handleNext);

        this.swatches.forEach((swatch) => swatch.removeEventListener('click', this.handleSwatchClick));
        this.groupCards.forEach((card) => card.removeEventListener('click', this.handleCardClick));

        if (this.stage) {
          this.stage.removeEventListener('pointerdown', this.handlePointerDown);
          this.stage.removeEventListener('pointerup', this.handlePointerUp);
        }

        this.removeEventListener('mouseenter', this.handlePointerEnter);
        this.removeEventListener('mouseleave', this.handlePointerLeave);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        this.stopAutoplay();

        if (this.resizeFrame) {
          window.cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = null;
        }

        if (this.animTimer) {
          window.clearTimeout(this.animTimer);
          this.animTimer = null;
        }

        this.groupCards.forEach((card) => {
          if (card._wrapTimer) {
            window.clearTimeout(card._wrapTimer);
            card._wrapTimer = null;
          }
        });
      }

      bindEvents() {
        window.addEventListener('resize', this.handleResize, { passive: true });

        if (this.prevBtn) this.prevBtn.addEventListener('click', this.handlePrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.handleNext);

        this.swatches.forEach((swatch) => swatch.addEventListener('click', this.handleSwatchClick));
        this.groupCards.forEach((card) => card.addEventListener('click', this.handleCardClick));

        if (this.slideCount > 1) {
          this.stage.addEventListener('pointerdown', this.handlePointerDown);
          this.stage.addEventListener('pointerup', this.handlePointerUp);
        }

        if (this.autoplayEnabled) {
          this.addEventListener('mouseenter', this.handlePointerEnter);
          this.addEventListener('mouseleave', this.handlePointerLeave);
          document.addEventListener('visibilitychange', this.handleVisibility);
        }
      }

      getLayoutConfig() {
        return window.matchMedia('(max-width: 749px)').matches ? MOBILE_SLOTS : DESKTOP_SLOTS;
      }

      getScale(config) {
        // 移动端：按屏幕宽度自适应，避免窄屏严重溢出。
        if (window.matchMedia('(max-width: 749px)').matches) {
          var mobileWidth = this.stage.clientWidth || config.baseWidth;
          return clamp(mobileWidth / config.baseWidth, config.minScale, config.maxScale);
        }
        // 桌面端：按设计稿 1440 画板等比还原布局（位置与大小同比例缩放），
        // 再叠加「卡片大小」滑块做整体微调，保证卡片位置严格对齐设计稿。
        var stageWidth = this.stage.clientWidth || config.baseWidth;
        return (stageWidth / config.baseWidth) * this.desktopScale;
      }

      getVisualOffset(index) {
        var forward = (index - this.activeSlideIndex + this.slideCount) % this.slideCount;
        if (forward === 0) return 0;
        if (forward === 1) return 1;
        if (forward === 2) return 2;
        if (forward === this.slideCount - 1) return -1;
        return forward < this.slideCount / 2 ? 99 : -99;
      }

      getSlotForOffset(offset, config) {
        if (offset === -1 || offset === 0 || offset === 1 || offset === 2) {
          return config.positions[String(offset)];
        }
        return offset < 0 ? config.positions.hiddenLeft : config.positions.hiddenRight;
      }

      applyCardLayout(card, slot, config, scale) {
        var stageWidth = this.stage.clientWidth || config.baseWidth;
        var stageHeight = this.stage.clientHeight || 1005;

        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var x, y;

        if (isMobile) {
          x = stageWidth / 2 + slot.x * scale;
          y = stageHeight / 2 + slot.y * scale;
        } else {
          x = stageWidth / 2 + (config.centerXOffset + slot.x) * scale;
          y = stageHeight * config.centerYRatio + slot.y * scale;
        }

        card.style.setProperty('--pps-card-x', x + 'px');
        card.style.setProperty('--pps-card-y', y + 'px');
        card.style.setProperty('--pps-card-w', slot.width * scale + 'px');
        card.style.setProperty('--pps-card-h', slot.height * scale + 'px');
        card.style.setProperty('--pps-card-rotation', slot.rotation + 'deg');
        card.style.setProperty('--pps-card-opacity', slot.opacity);
        card.style.setProperty('--pps-card-z', slot.zIndex);

        // 移动端相邻卡片虽透明，但保持可见以支持切换时的交叉淡入淡出；桌面端仍按 opacity 判定。
        var visible = slot.opacity > 0;
        if (isMobile) {
          var offset = parseInt(card.getAttribute('data-visual-offset'), 10);
          visible = offset >= -1 && offset <= 2;
        }
        card.classList.toggle('is-visible', visible);
      }

      applyBoardLayout(board, slot, config, scale) {
        var stageWidth = this.stage.clientWidth || config.baseWidth;
        var stageHeight = this.stage.clientHeight || 1005;
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var x, y;

        if (isMobile) {
          x = stageWidth / 2 + slot.x * scale;
          y = stageHeight / 2 + slot.y * scale;
        } else {
          x = stageWidth / 2 + (config.centerXOffset + slot.x) * scale;
          y = stageHeight * config.centerYRatio + slot.y * scale;
        }

        var bw = config.boardWidth * scale;
        var bh = config.boardHeight * scale;

        // 绿边「下唇」：让绿板相对照片中心朝卡片右下方轻微偏移，照片偏左上、底部/右侧留更多绿边（对齐 Figma）。
        var lipX = (config.lipXFrac || 0) * bw;
        var lipY = (config.lipYFrac || 0) * bh;
        if (lipX || lipY) {
          var rad = ((slot.rotation || 0) * Math.PI) / 180;
          x += lipX * Math.cos(rad) - lipY * Math.sin(rad);
          y += lipX * Math.sin(rad) + lipY * Math.cos(rad);
        }

        // 把绿板定位变量设到所在 group 上，使绿板与「装饰小手机包裹层」都能继承同一组位置。
        var target = board.parentElement || board;
        target.style.setProperty('--pps-board-x', x + 'px');
        target.style.setProperty('--pps-board-y', y + 'px');
        target.style.setProperty('--pps-board-w', bw + 'px');
        target.style.setProperty('--pps-board-h', bh + 'px');
        target.style.setProperty('--pps-board-rotation', slot.rotation + 'deg');
      }

      layoutCards(animate) {
        var config = this.getLayoutConfig();
        var scale = this.getScale(config);
        var canWrap = animate && !this.reduceMotion;

        // 绿色背景板固定在主卡（offset 0）槽位，切换时不动；它的尺寸/位置每次都相同，
        // 因此没有过渡、不会随卡片移动。颜色随所在 group 的淡入淡出整体切换。
        var mainSlot = config.positions['0'];
        this.boards.forEach((board) => {
          this.applyBoardLayout(board, mainSlot, config, scale);
        });

        this.groups.forEach((group) => {
          Array.prototype.slice.call(group.querySelectorAll('.pps__card')).forEach((card) => {
            var slideIndex = parseInt(card.getAttribute('data-slide-index'), 10) || 0;
            var prevOffset = parseInt(card.getAttribute('data-visual-offset'), 10);
            var visualOffset = this.getVisualOffset(slideIndex);
            var slot = this.getSlotForOffset(visualOffset, config);

            card.classList.toggle('is-active', visualOffset === 0);
            card.setAttribute('data-visual-offset', String(visualOffset));

            // 4 张卡片正好占满扇形 4 个槽位，没有隐藏缓冲位：绕回的那张会从扇形一端
            // (-1，左下) 跳到另一端 (2，右上)。若直接补间会横穿整个舞台，改用
            // 「原位淡出 → 瞬移到新槽位 → 淡入」衔接，避免卡片飞过屏幕。
            if (canWrap && !isNaN(prevOffset) && Math.abs(visualOffset - prevOffset) >= 3) {
              this.wrapCard(card, slot, config, scale);
            } else {
              if (card._wrapTimer) {
                window.clearTimeout(card._wrapTimer);
                card._wrapTimer = null;
              }
              card.classList.remove('is-wrapping');
              this.applyCardLayout(card, slot, config, scale);
            }
          });
        });
      }

      wrapCard(card, slot, config, scale) {
        if (card._wrapTimer) {
          window.clearTimeout(card._wrapTimer);
        }

        // 第一步：保留旧的 transform / 尺寸，只把透明度淡到 0（在原位置淡出）。
        card.classList.add('is-wrapping', 'is-visible');
        card.style.setProperty('--pps-card-opacity', 0);

        // 第二步：淡出完成后瞬移到新槽位（is-wrapping 关闭了 transform 过渡），随即淡入。
        card._wrapTimer = window.setTimeout(() => {
          this.applyCardLayout(card, slot, config, scale);
          card._wrapTimer = window.setTimeout(() => {
            card.classList.remove('is-wrapping');
            card._wrapTimer = null;
          }, 240);
        }, 220);
      }

      updateAll(animate) {
        this.classList.toggle('is-animating', animate && !this.reduceMotion);
        this.updateGroups();
        this.updateColorUi();
        this.layoutCards(animate);
        this.updateSlideUi();

        // 清除上一次未完成的计时器，避免连续快速点击时提前移除 is-animating 打断动画。
        if (this.animTimer) {
          window.clearTimeout(this.animTimer);
          this.animTimer = null;
        }
        if (animate && !this.reduceMotion) {
          this.animTimer = window.setTimeout(() => {
            this.classList.remove('is-animating');
            this.animTimer = null;
          }, 680);
        }
      }

      updateGroups() {
        this.groups.forEach((group, index) => {
          group.classList.toggle('is-active', index === this.activeColorIndex);
        });
      }

      updateColorUi() {
        var activeColor = '';
        var activeName = '';

        this.swatches.forEach((swatch, index) => {
          var isActive = index === this.activeColorIndex;
          swatch.classList.toggle('is-active', isActive);
          if (isActive) {
            swatch.setAttribute('aria-current', 'true');
            activeName = swatch.getAttribute('data-name') || '';
            activeColor = swatch.style.getPropertyValue('--swatch');
          } else {
            swatch.removeAttribute('aria-current');
          }
        });

        // 兜底：单颜色时没有 swatch 按钮，从当前激活的 group 取色。
        if (!activeColor && this.groups[this.activeColorIndex]) {
          activeColor = this.groups[this.activeColorIndex].style.getPropertyValue('--swatch');
        }

        this.descItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === this.activeColorIndex);
        });

        if (activeColor) {
          activeColor = activeColor.trim();
          if (this.currentDot) {
            this.currentDot.style.setProperty('--swatch', activeColor);
          }
          // 标题上方的装饰笔触跟随当前颜色一起切换。
          this.style.setProperty('--pps-decoration-color', activeColor);
        }

        if (this.currentName && activeName) {
          this.currentName.textContent = activeName;
        }
      }

      updateSlideUi() {
        if (this.progressFill) {
          var pct = ((this.activeSlideIndex + 1) / this.slideCount) * 100;
          this.progressFill.style.width = pct + '%';
        }

        if (this.prevBtn) {
          this.prevBtn.disabled = this.slideCount <= 1;
        }
        if (this.nextBtn) {
          this.nextBtn.disabled = this.slideCount <= 1;
        }
      }

      goToColor(index) {
        var target = clamp(index, 0, this.groups.length - 1);
        if (target === this.activeColorIndex) {
          return;
        }
        this.activeColorIndex = target;
        this.updateAll(true);
      }

      goToSlide(index) {
        if (this.slideCount <= 1) {
          return;
        }
        this.activeSlideIndex = (index + this.slideCount) % this.slideCount;
        this.updateAll(true);
      }

      // 连续顺播：先在当前颜色内切换 4 张卡片，4 张播完后跳到下一个颜色的第 1 张，
      // 如此把「颜色 × 4 张」串成一条循环，而不是一个颜色一个颜色地整体切换。
      advance(direction) {
        var totalColors = this.groups.length;
        if (this.slideCount <= 1 && totalColors <= 1) {
          return;
        }

        var nextSlide = this.activeSlideIndex + direction;
        var nextColor = this.activeColorIndex;

        if (nextSlide >= this.slideCount) {
          nextSlide = 0;
          nextColor = (this.activeColorIndex + 1) % totalColors;
        } else if (nextSlide < 0) {
          nextSlide = this.slideCount - 1;
          nextColor = (this.activeColorIndex - 1 + totalColors) % totalColors;
        }

        this.activeColorIndex = nextColor;
        this.activeSlideIndex = nextSlide;
        this.updateAll(true);
      }

      startAutoplay() {
        if (!this.autoplayEnabled || this.reduceMotion) {
          return;
        }
        if (this.slideCount <= 1 && this.groups.length <= 1) {
          return;
        }
        this.stopAutoplay();
        this.autoplayTimer = window.setInterval(() => {
          this.advance(1);
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      // 手动操作后重排计时，避免点击/滑动后立刻又被自动轮播打断。
      restartAutoplay() {
        if (!this.autoplayEnabled || this.reduceMotion) {
          return;
        }
        this.startAutoplay();
      }

      handlePrev() {
        this.advance(-1);
        this.restartAutoplay();
      }

      handleNext() {
        this.advance(1);
        this.restartAutoplay();
      }

      handleResize() {
        if (this.resizeFrame) {
          return;
        }

        this.resizeFrame = window.requestAnimationFrame(() => {
          this.resizeFrame = null;
          this.layoutCards();
        });
      }

      handleSwatchClick(event) {
        var index = parseInt(event.currentTarget.getAttribute('data-index'), 10);
        if (!isNaN(index)) {
          this.goToColor(index);
          this.restartAutoplay();
        }
      }

      handlePointerEnter() {
        this.stopAutoplay();
      }

      handlePointerLeave() {
        this.startAutoplay();
      }

      handleVisibility() {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }

      handleCardClick(event) {
        if (this.didSwipe) {
          return;
        }

        var visualOffset = parseInt(event.currentTarget.getAttribute('data-visual-offset'), 10);
        if (visualOffset === -1) {
          this.handlePrev();
        } else if (visualOffset > 0) {
          this.handleNext();
        }
      }

      handlePointerDown(event) {
        this.pointerActive = true;
        this.didSwipe = false;
        this.pointerStartX = event.clientX;
      }

      handlePointerUp(event) {
        if (!this.pointerActive) {
          return;
        }
        this.pointerActive = false;

        var delta = event.clientX - this.pointerStartX;
        if (Math.abs(delta) < 40) {
          return;
        }

        this.didSwipe = true;
        if (delta < 0) {
          this.handleNext();
        } else {
          this.handlePrev();
        }

        window.setTimeout(() => {
          this.didSwipe = false;
        }, 0);
      }
    }
  );
})();